export default __webpack_public_path__ + "static/media/health-first-min.fb7d1155.png";